import { render, staticRenderFns } from "./mobile-sheet.vue?vue&type=template&id=18bceaa6&scoped=true&"
import script from "./mobile-sheet.vue?vue&type=script&lang=ts&"
export * from "./mobile-sheet.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-sheet.vue?vue&type=style&index=0&id=18bceaa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bceaa6",
  null
  
)

export default component.exports